import React, { useState, useEffect } from 'react'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { formatDecimal } from '../../utils/tools'
import styles from './Select.module.scss'

export default function SelectNumber({value, setValue, fieldName, topLimit=9999, netherLimit=-9999 }) {
  const [localValue, setLocalValue] = useState(value)
  
  useEffect(() => {!isNaN(localValue) && typeof localValue === 'number' && setValue({value: localValue, name: fieldName});return () => {}} 
    ,[localValue]) // eslint-disable-line

  const changeValue = e => {
    let newValue = e.target.value || ''
    if(['','-','+'].includes(newValue)) setLocalValue(newValue)
    else newValue <= topLimit && newValue >= netherLimit && !isNaN(parseInt(newValue)) && setLocalValue(parseInt(newValue))
  }
  

  const down = () => setLocalValue(Math.max(value-1, netherLimit))
  const up = () => setLocalValue(Math.min(value+1, topLimit))

  const isPositive = !!(value >= 0)

  const stringValue = (typeof localValue !== 'number' || isNaN(formatDecimal(localValue))) ? localValue : formatDecimal(localValue)

  const handleLeaveComponent = () => typeof localValue !== 'number' && setLocalValue(value)
  
  return (
    <>
    <div className={styles['select-number']} onBlur={handleLeaveComponent}>
      <div className={ `${styles['select']} ${styles['input-number']}`}>
        <div className={`${styles['display']} ${styles[isPositive ? 'up' : 'down']}`}>
          <input style={{ width: stringValue?.length * 1.5 + "ch"}} value={stringValue} onChange={changeValue}/>
          <span>%</span>
        </div>
        <div className={styles['input-buttons']}>
          <button onClick={up}><ArrowDropUp/></button>
          <button onClick={down}><ArrowDropDown/></button>
        </div>
      </div>
    </div>
    </>
  )
}